import React from "react";
import PropTypes from "prop-types";

import BodyText from "core/BodyText";

import { StyledTextLink } from "./styles";

const BrowseAllContentTextLink = ({ contentCount, contentType, href }) => {
    const text =
        contentCount === 1
            ? `View 1 ${contentType}`
            : `View all ${contentCount} ${contentType}s`;

    return contentCount ? (
        <StyledTextLink to={href}>{text}</StyledTextLink>
    ) : null;
};

BrowseAllContentTextLink.propTypes = {
    contentCount: PropTypes.number.isRequired,
    contentType: PropTypes.oneOf(["icon", "photo", "collection"]).isRequired,
    href: PropTypes.string.isRequired
};

export default BrowseAllContentTextLink;
